import { render, staticRenderFns } from "./ProjectCreatePage.vue?vue&type=template&id=49d45e4f&"
import script from "./ProjectCreatePage.vue?vue&type=script&lang=ts&"
export * from "./ProjectCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports